import { DispDepositType, PaymentKbn } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "区分",
    keyword: "paymentKbn",
    type: "selectForm",
    requiredIcon: true,
    selectPropsList: TkGetCodeList(PaymentKbn),
  },
  {
    title: "振込先",
    keyword: "billingName",
    type: "label",
    requiredIcon: true,
  },
  {
    title: "摘要",
    keyword: "refComment",
    type: "label",
    inputProps: { maxLength: 30 },
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
  },
  {
    title: "振込先金融機関",
    keyword: "bankSelect",
    type: "bankSearch",
    requiredIcon: true,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "金融機関名",
    disabled: true,
    keyword: "bankName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
    text: "",
    requiredIcon: true,
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    onlyNumber: true,
    requiredIcon: true,
    type: "label",
    inputProps: { maxLength: 7 },
  },
  {
    title: "口座名義人名（半角ｶﾀｶﾅ）",
    keyword: "accountHolderKana",
    type: "name",
    requiredIcon: true,
    useFurigana: true,
    convertToHalfwidth: true,
    hafWidth: true,
  },
  {
    title: "金額",
    keyword: "transferAmount",
    type: "amount",
    inputProps: { maxLength: 9 },
    requiredIcon: true,
  },
  {
    title: "振込予定日",
    keyword: "transferDay",
    type: "date",
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
  },
  {
    keyword: "memo",
    type: "node",
    showLine: false,
  },
  {
    keyword: "approvalDateAndsymbolNo",
    type: "node",
    showLine: false,
  },
];

const schema = {
  paymentKbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  billingName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  refComment: {
    maxLength: {
      value: 30,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "30"),
    },
  },
  bankSelect: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  depositType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  accountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  accountHolderKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^([ｱ-ﾝｦ0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  transferAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
  transferDay: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const headList: any = [
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { fakeTableList, schema, headList };
